import React, { useState } from 'react';
import Playlogo from "../assets/images/PLAY.png";

const ComponentName = () => {        
    return (
        // <div className="relative bg-gradient-to-b from-green-50 to-green-100">
    <section className="overflow-visible">
        <div className="flex flex-col lg:flex-row lg:items-stretch lg:max-h-[700px] lg:min-h-[700px]">
            <div className="flex items-center justify-center w-full lg:order-2 lg:w-7/12">
                <div className=" px-3  sm:px-3  ">
                    <div className="flex flex-col  py-10 px-3 justify-between flex-1 ">
                        <div>
                            <h1 className="text-4xl font-bold text-[#e58505] sm:text-6xl xl:text-7xl">Download the Safaiwala App</h1>
                            <p className="mt-6 text-base text-black sm:text-xl">Book trusted cleaning services anytime, anywhere. Download the Safaiwala app to schedule cleaning, choose your time, and enjoy a clean home with just a few taps.</p>
                            <a href="#" title="" className="inline-flex items-center px-6 py-5 text-base font-semibold text-[#fff] transition-all duration-200 bg-[#079dcc] mt-9" role="button"> Get started for free </a>
                        </div>

                            <div className="mt-8 border-t-2 border-black">
                                <div className="pt-8 sm:flex sm:items-center sm:justify-between ">
                                    <p className="text-base font-semibold text-black">App available on</p>

                                    <div className="
            mt-5 sm:mt-6 left-[10px]
            flex flex-wrap  gap-2
          ">
               <a
                                            href="https://apps.apple.com/in/app/the-safai-wala/id6755910406"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="w-32 sm:w-36 md:w-40 h-12 sm:h-14 md:h-16
                         inline-flex items-center justify-center
                         transition-transform hover:scale-105"
                                        >
                                            <img
                                                src="/download-on-the-app-store.svg"
                                                alt="App Store"
                                                className="w-full h-full object-contain"
                                            />
                                        </a>
                                        <a
                                            href="https://play.google.com/store/apps/details?id=com.yashrajsingh163.thesafaiwala"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="w-36 sm:w-40 md:w-44 h-12 sm:h-14 md:h-16
                         inline-flex items-center justify-center
                         transition-transform hover:scale-105"
                                        >
                                            <img
                                                src="/Google_Play_Store_badge_EN.svg"
                                                alt="Google Play"
                                                className="w-full h-full object-contain"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>

            <div className="relative w-full px-3 overflow-hidden lg:w-5/12 lg:order-1">
  <div
    className="
      relative
      w-full
      max-w-[420px]
      mx-auto
      lg:absolute
      lg:w-[800px]
      lg:max-w-none
      lg:bottom-0
      lg:left-0
    "
  >
    <img
      className="w-full h-auto object-contain"
      src={Playlogo}
      alt=""
    />
  </div>
</div>

        </div>
    </section>
// </div>

    )
}
export default ComponentName;